import {
  Command as MT4Command,
  MT4Connector,
  CloseTrade,
  ModifyTrade,
  TradeCommandType,
  TradeObject,
  TradeType,
} from '@bdswiss/mt4-connector'
import { Observable } from 'rxjs'
import { Subject } from 'rxjs'
import genUuid from 'uuid'
import { MT4_TIMEOUT } from '../constants'
// import { v4 as uuid } from 'uuid';

export class Mt4TraderService {
  private connector: MT4Connector

  public constructor(connector: MT4Connector) {
    this.connector = connector
  }

  public openTrade(
    symbol: string,
    cmd: TradeCommandType | null,
    volume: number,
    price?: number,
    sl?: number,
    tp?: number,
    signalId?: string
  ): Observable<TradeObject> {
    const result = new Subject()
    this.connector
      .openOrder({
        ...{
          symbol,
          volume,
          uuid: genUuid(),
          platform: 'WT',
        },
        ...(cmd ? { cmd } : {}),
        ...(price ? { price } : {}),
        ...(sl ? { sl } : {}),
        ...(tp ? { tp } : {}),
        ...(signalId ? { signalId } : {}),
      })
      .subscribe(result)

    return (result.asObservable() as Observable<TradeObject>).timeout(MT4_TIMEOUT)
  }

  public closeTrade(order: CloseTrade | TradeObject): Observable<TradeObject> {
    const result = new Subject()
    this.connector.closeOrder(order).subscribe(result)
    return (result.asObservable() as Observable<TradeObject>).timeout(MT4_TIMEOUT)
  }

  public closeAllTrades() {
    this.connector.sendCommand(MT4Command.CLOSE_ALL_TRADES, null)
  }

  public modifyTrade(tradePayload: ModifyTrade, type?: TradeType): Observable<TradeObject> {
    const result = new Subject()
    this.connector.modifyOrder(tradePayload).subscribe(result)
    return (result.asObservable() as Observable<TradeObject>).timeout(MT4_TIMEOUT)
  }

  public cancelPendingTrade(order: CloseTrade | TradeObject): Observable<TradeObject> {
    const result = new Subject()
    this.connector.cancelPendingOrder(order).subscribe(result)
    return (result.asObservable() as Observable<TradeObject>).timeout(MT4_TIMEOUT)
  }
}
